/*
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-07-11 00:06:58
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2024-07-14 23:56:47
 */
import request from './request';

// 获取项目分类数据
export function getProjectCaseCategory() {
  return request('/project/classList');
}
// 获取项目列表
export function getProjectCaseList(params) {
  return request('/project', {
    method: 'GET',
    params
  });
}
// 提交需求
export function submitNewRequest(params) {
  return request('/project/requirement', {
    method: 'POST',
    params
  });
}
// 获取项目案例详情
export function getServiceDetail(id) {
  return request(`/project/${id}`);
}
// 新增项目
export function addCase(params) {
  return request(`/project`, {
    method: 'POST',
    params
  });
}
// 修改项目
export function editCase(params) {
  return request(`/project`, {
    method: 'PUT',
    params
  });
}
// 删除项目
export function deleteProject(id) {
  return request(`/project/${id}`, {
    method: 'DELETE'
  });
}
// 下载解决方案
export function downloadProjectCase(id) {
  return request(`/project/download?projectId=${id}`, {
      method: 'POST'
  });
}
// 解决方案订单
export function getUserProjectCaseOrder(id) {
    return request(`/project/payed`, {
        method: 'GET',
    });
}

// 项目案例的项目列表下载
export function projectItemDownload(id) {
    return request(`/project/item/download?projectItemId=${id}`, {
        method: 'GET',
    });
}

// 项目首页推荐
export function getHotProject(params) {
    return request(`/project/hot/list`, {
        method: 'GET',
        params
    });
}